import * as React from 'react';

import { MentionsState } from '@web/richText/TextEditorInner/hooks/useMentions';

import { ItemIcon } from '../ItemIcon/ItemIcon';

import { Container, Description, IconContainer, Name, Wrapper } from './item.styles';

type Props = {
  index: number;
  style: Record<string, string | number>;
  data: MentionsState;
};

const Item: React.FC<React.PropsWithChildren<Props>> = ({ index, style, data }) => {
  const { filteredPersonas, index: activeIndex, setIndex, onPersonaSelect } = data;
  const persona = filteredPersonas[index];

  return (
    <Container style={style}>
      <Wrapper
        isActive={index === activeIndex}
        onMouseDown={(event): void => {
          event.preventDefault();
          event.nativeEvent.stopImmediatePropagation();
          onPersonaSelect();
        }}
        onMouseEnter={(): void => setIndex(index)}>
        <IconContainer>
          <ItemIcon persona={persona} />
        </IconContainer>

        <Name>{persona.displayName}</Name>
        <Description>{persona.mentionSubtitle}</Description>
      </Wrapper>
    </Container>
  );
};

export default Item;
